<template>
    <div class="fort-layout">
        <div class="grid">
            <div class="grid-inner">
                <div class="grid-row clear" v-for="row in rows" :key="`row-${row}`">
                    <div class="hexagon-wrapper" v-for="hex in hexes" :key="`hex-${row}${hex}`">
                        <div class="hexagon"
                            :class="{
                                'control-base': hasControlBase(`${row},${hex}`),
                                'dark': isFourPlayerTile(`${row},${hex}`)
                            }"
                        >
                            <div class="card-fort-wrapper" v-if="fortInPosition(`${row},${hex}`)">
                                <div class="card-fort">
                                    <icon class="icon icon-fort" icon="fort" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import find from 'lodash.find';
import {
    CONTROL_BASES,
    FOUR_PLAYER_TILES,
} from '../Game/Game-types';

export default {
    name: 'Board',
    props: ['forts'],
    data() {
        return {
            hexes: [0, 1, 2, 3, 4, 5, 6],
            rows: [0, 1, 2, 3, 4, 5, 6],
            corners: new Array(4),
        };
    },
    computed: {

    },
    methods: {
        fortInPosition(position) {
            return find(this.forts, { position });
        },
        hasControlBase(position) {
            return CONTROL_BASES.includes(position);
        },
        isFourPlayerTile(position) {
            return FOUR_PLAYER_TILES.includes(position);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

.fort-layout {
    display: inline-block;
    max-height: 120px;
    overflow: hidden;
    padding: 10px 0;
    background: rgba(255,255,255,.7);
    box-shadow: 0 0 3px 2px $dark-cream;
    border-radius: 4px;

    .grid {
        box-sizing: border-box;
        overflow: hidden;
        width: 200px;
        margin: 0 auto;
        text-align: center;
        position: relative;
    }

    .grid-row {
        position: relative;
        margin: 0 auto;
        padding: 0;
    }

    .clear:after {
        content: "";
        display: block;
        clear: both;
    }

    .hexagon-wrapper {
        float: left;
        overflow: hidden;
        padding: 0 0 15.4% 0;
        position: relative;
        transform: rotate(-60deg) skewY(30deg);
        visibility: hidden;
        width: 13.4%;
    }

    .hexagon {
        background: $tile;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        transform: skewY(-30deg) rotate(60deg);
        visibility: visible;
        width: 100%;

        &.dark {
            background: $dark-tile;
        }

        .card-fort-wrapper {
            align-self: center;
            transform: rotate(30deg);

            .card-fort {
                background: $dark-brown;
                width: 21px;
                height: 21px;
                border-radius: 50%;
                display: flex;
                justify-content: center;

                .icon-fort {
                    width: 13px;
                    fill: white;
                    align-self: center;
                }
            }
        }

        &.control-base {

            &::after {
                background-image: url('../../assets/control_base.svg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: 72%;
                bottom: 0;
                content: '';
                left: 0;
                opacity: 0.7;
                position: absolute;
                right: 0;
                top: 0;
                transform: rotate(30deg);
                z-index: -1;
            }
        }
    }

    .grid-row .hexagon-wrapper {
        margin: 0 .4%;
    }

    .grid-row:nth-of-type(1) {
        transform: translateX(7%);

        .hexagon-wrapper {
            &:first-of-type {

                .hexagon {
                    visibility: hidden;
                }
            }
        }
    }

    .grid-row:nth-of-type(2) {
        transform: translateX(14%) translateY(-20%);
    }

    .grid-row:nth-of-type(3) {
        transform: translateX(21%) translateY(-40%);
    }

    .grid-row:nth-of-type(4) {
        transform: translateX(28%) translateY(-60%);
    }

    .grid-row:nth-of-type(5) {
        transform: translateX(35%) translateY(-80%);
    }

    .grid-row:nth-of-type(6) {
        transform: translateX(42%) translateY(-100%);
    }

    .grid-row:nth-of-type(7) {
        transform: translateX(49%) translateY(-120%);

        .hexagon-wrapper {
            &:last-of-type {

                .hexagon {
                    visibility: hidden;
                }
            }
        }
    }

    .grid-inner {
        transform: rotate(-30deg) scale(.6) translateX(-7.5%) translateY(-24%);
    }
}

.rules {

    .fort-layout {
        box-shadow: 0 0 3px 2px $light-gray;
    }
}

</style>
